import { render } from "./Homeview.vue?vue&type=template&id=dd8dd054&scoped=true"
import script from "./Homeview.vue?vue&type=script&lang=js"
export * from "./Homeview.vue?vue&type=script&lang=js"

import "@/assets/css/globalcn.css?vue&type=style&index=0&id=dd8dd054&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd8dd054"]])

export default __exports__